// Auto-generated skeleton for CraftsmanTaskProcess

export const CraftsmanTaskProcess: Api.CraftsmanTaskProcess = {
  id: 0,
  hp_id: null,
  name: '',
  created: null,
  updated: null,
};

